var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_825_532",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 14,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.96C12.4546 13.96 14.5648 12.0507 15.4941 11.0606C15.8053 10.729 15.8053 10.231 15.4941 9.89944C14.5648 8.90932 12.4546 7 10 7C7.54543 7 5.43519 8.90932 4.5059 9.89944C4.19469 10.231 4.19469 10.729 4.5059 11.0606C5.43519 12.0507 7.54543 13.96 10 13.96Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.9312C10.3978 11.9312 10.7794 11.7785 11.0607 11.5066C11.342 11.2346 11.5 10.8658 11.5 10.4812C11.5 10.0967 11.342 9.72787 11.0607 9.45595C10.7794 9.18402 10.3978 9.03125 10 9.03125C9.60218 9.03125 9.22064 9.18402 8.93934 9.45595C8.65804 9.72787 8.5 10.0967 8.5 10.4812C8.5 10.8658 8.65804 11.2346 8.93934 11.5066C9.22064 11.7785 9.60218 11.9312 10 11.9312Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_825_532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.80078 4.51953C2.80078 3.96725 3.2485 3.51953 3.80078 3.51953H16.2008C16.7531 3.51953 17.2008 3.96725 17.2008 4.51953V16.4395C17.2008 16.9918 16.7531 17.4395 16.2008 17.4395H3.80078C3.2485 17.4395 2.80078 16.9918 2.80078 16.4395V4.51953Z",
    fill: "#94A1BB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon_view.78fe38fed01d642ed7e6c0b0075b3e1d.svg";
export { ForwardRef as ReactComponent };